import PropTypes from 'prop-types';
import ShareBetImpl from './share-bet.js';
import MojitoCore from 'mojito/core';

/**
 * A module that displays a share icon when a bet can be shared.
 * Clicking the icon opens a dialog with sharing options.
 *
 * @class ShareBet
 * @name module
 * @memberof Mojito.Modules.ShareBet
 */

/**
 * ShareBet prop types.
 *
 * @property {Mojito.Services.Bets.types.Bet} bet - The bet to be shared.
 * @memberof Mojito.Modules.ShareBet.module
 */
const propTypes = {
    bet: PropTypes.object.isRequired,
};

export default MojitoCore.Presentation.UIView('ShareBet', ShareBetImpl, propTypes);
